'use client'

import {OfferValue} from '../product-detail/offers'
import {observer} from 'mobx-react'
import React from 'react'

import {ProductWithVariantsListItemViewModel} from '@/src/entities/product/model'

import * as UI from '@/src/features/catalog/product-list/product-list-item.styled'

import Modal from '@/src/shared/ui/modal'

import * as ProductListItemUI from './product-list-item.styled'
import {useBasket} from '@/src/entities/basket'
import {isProductViewModelWithVariants} from '@/src/entities/product/helpers/validators'
import {Routes} from '@/src/config/routes'
import {useRouter} from 'nextjs-toploader/app'
import {sortAttributeValues} from '@/src/core/domain/entities/product'
import values from 'lodash/values'

interface AttributesModalProps {
  productListItemVM: ProductWithVariantsListItemViewModel
  open: boolean
  setOpen: (open: boolean) => void
}

export const AttributesModal = observer(
  ({productListItemVM, open = false, setOpen}: AttributesModalProps) => {
    const basket = useBasket()
    const router = useRouter()

    const inBasket = basket.haveProduct(
      productListItemVM.product,
      isProductViewModelWithVariants(productListItemVM)
        ? (productListItemVM.variants.variant ?? undefined)
        : undefined,
    )

    return (
      <Modal
        open={open}
        onCancel={() => setOpen(false)}
        width={{
          xs: '90%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '40%',
        }}>
        {(productListItemVM.variants.variants ?? []).length > 0 && (
          <ProductListItemUI.ProductProperties>
            {productListItemVM.variants.attributes.map(attribute => (
              <ProductListItemUI.ProductPropertyContainer
                key={`property-${productListItemVM.product.id}-${attribute.code}`}>
                <ProductListItemUI.ProductPropertyName>
                  {attribute.name}
                </ProductListItemUI.ProductPropertyName>
                <ProductListItemUI.ProductPropertyValue>
                  {sortAttributeValues(values(attribute.values)).map(attributeValue => (
                    <ProductListItemUI.ProductPropertyValueItem
                      as={OfferValue}
                      key={`property-${productListItemVM.product.id}-${attribute.code}-${attributeValue.value}`}
                      active={attributeValue.active}
                      disabled={attributeValue.disabled}
                      onChange={() =>
                        productListItemVM.variants.setSelectedAttribute(
                          attribute.code,
                          attributeValue.value,
                        )
                      }>
                      {attributeValue.title}
                    </ProductListItemUI.ProductPropertyValueItem>
                  ))}
                </ProductListItemUI.ProductPropertyValue>
              </ProductListItemUI.ProductPropertyContainer>
            ))}
          </ProductListItemUI.ProductProperties>
        )}

        {productListItemVM.price && (
          <ProductListItemUI.ProductPrices>
            {productListItemVM.price.price && (
              <ProductListItemUI.ProductPrice>
                {productListItemVM.price.price_formatted}
              </ProductListItemUI.ProductPrice>
            )}
            {productListItemVM.price.old_price &&
              productListItemVM.price.old_price != productListItemVM.price.price && (
                <ProductListItemUI.ProductOldPrice>
                  {productListItemVM.price.old_price}
                </ProductListItemUI.ProductOldPrice>
              )}
          </ProductListItemUI.ProductPrices>
        )}
        <ProductListItemUI.ProductActions>
          {productListItemVM.price ? (
            productListItemVM.price.price > 0 &&
            productListItemVM.available &&
            productListItemVM.variants.variant && (
              <UI.ProductBuyBtn
                data-testid="buy-btn"
                onClick={async () => {
                  if (!inBasket) {
                    await productListItemVM.onClickBuyButton('mobile')
                  } else {
                    await router.push(Routes.basket.page)
                  }
                }}>
                {(inBasket && 'В корзину') || 'Купить'}
              </UI.ProductBuyBtn>
            )
          ) : (
            <></>
          )}
        </ProductListItemUI.ProductActions>
      </Modal>
    )
  },
)
